import { Router } from '@angular/router';

/**
 *
 * @param router -> page router bilgisi
 * @param extras -> navigation.extras.queryParams objesini direkt almak için kullanılabilecek field
 */
export function navigationUtil(router: Router, extras?: boolean) {
    const navigation = router?.lastSuccessfulNavigation;

    if (navigation) {
        if (extras) {
            return navigation.extras?.queryParams;
        } else {
            const state = navigation.extras?.state;
            if (state?.obj?.queryParams) {
                return state.obj.queryParams;
            }
        }
    }
    return;
}
